import { create } from 'zustand'

interface LeagueStaffState {
  requestMentorModal: boolean
  setRequestMentorModal: (val: boolean) => void
}

const leagueStaffStoreStates = (set: any): LeagueStaffState => ({
  requestMentorModal: false,
  setRequestMentorModal: (val: boolean) =>
    set(() => ({ requestMentorModal: val })),
})

export const leagueStaffStore = create<LeagueStaffState>(leagueStaffStoreStates)
